import React from 'react'

function IndustrialProduct() {
  return (
    <div>
      <h1>تسجيل منتج صناعي</h1>
    </div>
  )
}

export default IndustrialProduct
